// themeConfig.js
// Edit this file to change the default theme and layout
// After changing, rebuild the app for changes to take effect

const themeConfig = {
    // Available themes: 'default', 'corporate-blue', 'moba'
    theme: 'ux',
    
    // Available layouts: 'centered', 'left-aligned'
    layout: 'left-aligned',
    
    // Allow runtime changes (via ThemeTester)
    allowRuntimeChanges: true
  };
  
  export default themeConfig;